import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const POOJA_EVENTS_POOJA_EVENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/pooja-events',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:PoojaEvents',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.PoojaEvents',
      },
    ]);
  };
}
